import { StaticMenuExperimentVariants } from 'experiments/static-menu/staticMenuExperimentVariants';
import { RunningExperiments, useExperiments } from 'state/experiments';

export const useStaticMenuExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.StaticMenu, StaticMenuExperimentVariants.Treatment);
};
